import React from 'react';
import './Popup.css';

export const Popup = (props) => {

  const handleOutsideClick = (e) => {
    if (e.target.className === "popup") {
      props.onClose()
    };
  };

  return (props.trigger) ? (
    <div className="popup" onClick={handleOutsideClick}>
        <div className="popup-inner">
            <button 
              className="popup-close" 
              onClick={() => props.onClose()}
            >X</button>
            {props.children}
        </div>
    </div>
  ) : null
};